import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../../api'

const initialState = {
    minimumForeignLanguage: "",
    minimumMath: "",
    minimumNaturalScience: "",
    earnedForeignLanguage: "",
    earnedMath: "",
    earnedNaturalScience: "",
    earnedHoursPU: "",
    group: ""
}

const transform = (data) => {
    let transformedData = {};

    transformedData = {
        minimumForeignLanguage: data?.minimumRequiredConfiguration?.foreignLanguage ?? "",
        minimumMath: data?.minimumRequiredConfiguration?.math ?? "",
        minimumNaturalScience: data?.minimumRequiredConfiguration?.naturalScience ?? "",
        earnedForeignLanguage: data?.collegePrepUnits?.earnedForeign ?? "",
        earnedMath: data?.collegePrepUnits?.earnedMath ?? "",
        earnedNaturalScience: data?.collegePrepUnits?.earnedScience ?? "",
        earnedHoursPU: data?.earnedHoursPU ?? "",
        group: data?.group ?? ""
    }

    return transformedData
}

const collegePrepSlice = createSlice({
    name: 'applicant-detail-college-prep',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            graphqlApi.endpoints.getApplicationDetails.matchFulfilled,
            (state, { payload }) => {
                if (payload?.details?.collegePrepUnits) {
                    return transform(payload?.details?.collegePrepUnits);
                }
            }
        )
    }
});

export const selectCollegePrepData = (state) => state.collegePrepSlice

export default collegePrepSlice.reducer;